export default {
    // backend: 'https://backend-staging.hack2skill.com/'
    backend: 'https://backend-api.hack2skill.com/'
    // backend: 'http://localhost:3000/'
}